import { styled } from '@mui/material/styles';
import { QTableRow } from '@kw/quokka-ui'
import { KwTableBody } from './KwTableBody';

export const KwTableRow = styled(QTableRow)`
  ${props => (props.onClick ? `cursor: pointer;` : '')}
  ${KwTableBody} & {
    background-color: ${props => (props.selected ? 'rgba(79, 134, 142, 0.1)' : 'transparent')};
    &:hover {
      background-color: rgba(79, 134, 142, 0.1);
    }
  }
`;
